import type { ComponentSchema } from '../../../../../schema-types'
import { CONTENT_PAGES, CONTENT_POINT_SCHEMA, headingFields, SECTION_STYLE_FIELDS } from './_fields'

/** A tint band: a picture beside two to four benefit points. */
export const schema: ComponentSchema = {
  type: 'story',
  label: 'Story band',
  description: 'Why shop with you: a picture beside short benefit points.',
  supportedPages: CONTENT_PAGES,
  variants: [{ id: 'v1', label: 'Picture and points' }],
  commonFields: [
    ...headingFields({ eyebrow: 'Our promise', title: 'Why shop with us', subtitle: 'Good products, honest prices and service you can count on.' }),
    { key: 'image', label: 'Picture', type: 'image' },
    {
      key: 'points',
      label: 'Points',
      type: 'array',
      itemSchema: CONTENT_POINT_SCHEMA,
      default: [
        { icon: 'secure', title: 'Quality checked', body: 'Every product is checked before it leaves our store.' },
        { icon: 'shipping', title: 'Delivered fresh', body: 'Packed with care and delivered quickly to your door.' },
        { icon: 'support', title: 'Real support', body: 'Questions about an order? Call or message us any day.' },
      ],
    },
    { key: 'ctaLabel', label: 'Button text', type: 'localized-string', default: '' },
    { key: 'ctaLink', label: 'Button link', type: 'string', default: '' },
    ...SECTION_STYLE_FIELDS,
  ],
}
